import { render, staticRenderFns } from "./uploadMaterial.vue?vue&type=template&id=4d5f631a&scoped=true&"
import script from "./uploadMaterial.vue?vue&type=script&lang=js&"
export * from "./uploadMaterial.vue?vue&type=script&lang=js&"
import style0 from "./uploadMaterial.vue?vue&type=style&index=0&id=4d5f631a&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d5f631a",
  null
  
)

export default component.exports